/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {Subscription} from 'rxjs';
import {GlobalSearchCriteriaService} from '../../services/global-search-criteria.service';
import {inputCriteriaTypeConfiguration} from '../configuration/input-criteria-type-configuration';
import {InputCriteriaTypeMapper} from '../mappers/input-criteria-type.mapper';

@Component({
    selector: 'app-input-criteria-text',
    templateUrl: './input-criteria-text.component.html',
    styleUrls: ['./input-criteria-text.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputCriteriaTextComponent implements OnInit, OnDestroy {
    @Input() searchCriteriaTextChange: EventEmitter<void>;
    @Input() isInputTypeNumber: boolean;

    @Output() searchCriteriaTextReset = new EventEmitter<void>();

    inputText: string;
    private subscriptions = new Subscription();

    constructor(private globalSearchService: GlobalSearchCriteriaService) {
    }

    ngOnInit(): void {
        this.subscriptions.add(this.searchCriteriaTextChange?.subscribe(() => {
            this.clearTypedInput();
        }));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    get isInputActive(): boolean {
        return this.globalSearchService.hasSelectedFilter();
    }

    get dynamicInputPlaceholder(): string {
        let placeholder = '';
        const criterionFilterName = this.globalSearchService.getSelectedSearchCriterionName();
        if (this.isInputActive) {
            if (criterionFilterName != null) {
                placeholder = `${inputCriteriaTypeConfiguration.inputTextPlaceholder} ${criterionFilterName}`;
            } else {
                placeholder = inputCriteriaTypeConfiguration.inputTextPlaceholder;
            }
        }
        return placeholder;
    }

    onEnter(): void {
        const queryFilter = InputCriteriaTypeMapper.fromInputCriteriaTypeToQueryChipsAreaModel(
                this.globalSearchService.getSelectedSearchCriterionFilter(),
                this.inputText);

        if (queryFilter) {
            this.globalSearchService.addCriterionFilterToQuery(queryFilter);

            this.clearTypedInput();
            this.searchCriteriaTextReset.emit();
        }
    }

    private clearTypedInput(): void {
        this.inputText = '';
    }
}
